export const StatusType = {
    Idle: 'idle',
    Loading: 'loading',
    Completed: 'completed',
    Error: 'error',
    Confirmed: 'confirmed',
};
